"use client";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store";
import { getCommunityGroupsByAdminId } from "../../../../Redux/Community Groups/group/slice";
import { CommunityGroup } from "../../../../Redux/Community Groups/group/types";

const ChannelCards = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { adminGroups, loading, error } = useSelector((state: RootState) => state.communityGroups);

  useEffect(() => {
    // Fetch top 10 community groups
    dispatch(getCommunityGroupsByAdminId());
  }, [dispatch]);

  // Helper function to render a single channel card
  const renderChannelCard = (group: CommunityGroup, index: number) => (
    <div key={group._id} className="d-flex justify-content-between align-items-end pb-2">
      <a href={`/channel-view`}>
        <div className="w-100 cursor-pointer">
          <div className="d-flex justify-content-start align-items-end gap-3">
            <div>
              <div className="text-center categories-bg-mini">
                <img
                  alt={group.name}
                  src={group.image || "../assets/img/profile/profile-3.jpg"}
                  className="avatar avatar-custom p-2"
                />
              </div>
            </div>
            <div className="mt-2">
              <b className="text-sm fw-bolder text-black">
                {group.name}
                <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
              </b>
              <div className="lh-0">
  <b className="text-black fw-normal text-xs">
    {group.description
      ? group.description.split(" ").slice(0, 6).join(" ") + (group.description.split(" ").length > 6 ? "..." : "")
      : "N/A"}
  </b>
</div>

            </div>
          </div>
        </div>
      </a>
      <div className="w-15 text-center">
        <div>
          <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
            <div
              id={`storeOptions-${index}`}
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
            </div>
            <ul className="dropdown-menu" aria-labelledby={`storeOptions-${index}`}>
              <li>
                <a className="dropdown-item fw-bold text-black" href="/">
                  Pin
                </a>
              </li>
              <li>
                <a className="dropdown-item fw-bold text-black" href="/">
                  Mute
                </a>
              </li>
              <li>
                <a className="dropdown-item fw-bold text-black" href="/">
                  Unsubscribe
                </a>
              </li>
            </ul>
          </li>
        </div>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="display-max">
        <div className="text-center p-4">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="display-max">
        <div className="alert alert-danger" role="alert">
          Error loading community groups: {error}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="display-max">
        <div>
          {adminGroups && adminGroups.length > 0 ? (
            adminGroups.slice(0, 10).map((group: CommunityGroup, index: number) => (
              <React.Fragment key={group._id}>
                {renderChannelCard(group, index)}
                {index < Math.min(adminGroups.length, 10) - 1 && (
                  <hr className="horizontal dark" />
                )}
              </React.Fragment>
            ))
          ) : (
            <div className="text-center p-4">
              <p className="text-muted">No community groups available</p>
            </div>
          )}
        </div>
      </div>
      <div className="display-mini display-mob">
        <div>
            {adminGroups && adminGroups.length > 0 ? (
            adminGroups.slice(0, 10).map((group: CommunityGroup, index: number) => (
              <React.Fragment key={group._id}>
                {renderChannelCard(group, index)}
                {index < Math.min(adminGroups.length, 10) - 1 && (
                  <hr className="horizontal dark" />
                )}
              </React.Fragment>
            ))
          ) : (
            <div className="text-center p-4">
              <p className="text-muted">No community groups available</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ChannelCards;
